import type { RecommendHub } from "./types";

export const RECOMMEND_HUBS: RecommendHub[] = [
  {
    slug: "translation-th",
    titleTh: "แนะนำบริการแปลเอกสาร สำหรับคนไทย",
    h1: "แนะนำบริการแปลเอกสารสำหรับคนไทย 2026: เลือกอย่างไรให้หน่วยงานปลายทางรับรอง",
    metaTitle: "แนะนำบริการแปลเอกสาร สำหรับคนไทย 2026 | เลือกให้ผ่านครั้งแรก",
    metaDesc:
      "รวมแนวทางเลือกบริการแปลเอกสารสำหรับคนไทย ทั้งงานยื่นวีซ่า เรียนต่อ ทำงานต่างประเทศ และงานธุรกิจ พร้อมเกณฑ์ตรวจคำแปลก่อนยื่น ปรึกษาทีมงานได้",
    quickAnswer:
      "การเลือกบริการแปลเอกสารสำหรับคนไทยให้ยึดปลายทางเป็นหลัก ถ้าเอกสารต้องผ่านกรมการกงสุลต้องใช้คำแปลที่กองสัญชาติและนิติกรณ์ตรวจผ่านได้ ถ้ายื่นสถานทูตต้องดูว่าสถานทูตนั้นกำหนดนักแปลขึ้นทะเบียนหรือไม่ และถ้ายื่นออสเตรเลียต้องเป็นนักแปล NAATI เท่านั้น เลือกผู้ให้บริการที่ระบุชื่อผู้แปล เลขทะเบียน และรับแก้ไขจนหน่วยงานรับเอกสาร",
    audience: "ไทย",
    intro: [
      "คนไทยที่ต้องใช้คำแปลเอกสารมักเจอปัญหาเดียวกัน คือแปลถูกต้องตามภาษาแล้วแต่หน่วยงานปลายทางยังไม่รับ เพราะแต่ละปลายทางกำหนดรูปแบบการรับรองคำแปลไม่เหมือนกัน คำแปลที่กรมการกงสุลรับรองได้ อาจไม่ใช่รูปแบบที่กระทรวงศึกษาธิการของประเทศปลายทางต้องการ",
      "หน้านี้รวมแนวทางเลือกบริการแปลตามจุดประสงค์การใช้งานจริง แยกตามกลุ่มเอกสารที่พบมากที่สุด เพื่อให้ท่านเลือกเส้นทางที่ถูกตั้งแต่ครั้งแรกและไม่ต้องเสียเวลาแปลซ้ำ",
    ],
    serviceLinks: [
      { label: "บริการแปลเอกสารรับรองทุกภาษา", href: "/translation" },
      { label: "รับรองนิติกรณ์กรมการกงสุล", href: "/services/mfa-legalization" },
      { label: "นักแปล NAATI ออสเตรเลีย", href: "/naati" },
    ],
  },
  {
    slug: "translation-foreign",
    titleTh: "แนะนำบริการแปลเอกสาร สำหรับชาวต่างชาติในไทย",
    h1: "แนะนำบริการแปลเอกสารสำหรับชาวต่างชาติในประเทศไทย 2026",
    metaTitle: "แนะนำบริการแปลเอกสาร ชาวต่างชาติในไทย 2026 | ครบทุกปลายทาง",
    metaDesc:
      "แนวทางเลือกบริการแปลเอกสารต่างประเทศเป็นภาษาไทยและภาษาอังกฤษ สำหรับใบอนุญาตทำงาน วีซ่า จดทะเบียนสมรส และตั้งบริษัทในไทย ปรึกษาทีมงานได้",
    quickAnswer:
      "ชาวต่างชาติที่ใช้เอกสารในประเทศไทยต้องมีคำแปลภาษาไทยที่หน่วยงานรับได้ และเอกสารต้นทางต้องผ่านการรับรองจากประเทศที่ออกเอกสารก่อน จากนั้นรับรองต่อที่สถานเอกอัครราชทูตของประเทศนั้นในไทยหรือใช้เส้นทางอนุสัญญาเฮก แล้วจึงนำไปรับรองนิติกรณ์ที่กรมการกงสุล เลือกผู้ให้บริการที่ทำทั้งคำแปลและเดินเรื่องรับรองในชุดเดียว",
    audience: "ต่างชาติ",
    intro: [
      "เอกสารที่ออกโดยหน่วยงานต่างประเทศจะใช้ในประเทศไทยได้เมื่อผ่านสองเงื่อนไข คือความถูกต้องของสายการรับรองจากประเทศต้นทาง และคำแปลภาษาไทยที่หน่วยงานผู้รับยอมรับ การขาดข้อใดข้อหนึ่งทำให้เรื่องถูกตีกลับทันที",
      "หน้านี้อธิบายวิธีเลือกบริการแปลตามงานที่ชาวต่างชาติในไทยต้องทำจริง ตั้งแต่ใบอนุญาตทำงาน วีซ่าระยะยาว การจดทะเบียนสมรส ไปจนถึงเอกสารตั้งบริษัท",
    ],
    serviceLinks: [
      { label: "Certified translation service", href: "/en/services/certified-translation" },
      { label: "รับรองนิติกรณ์กรมการกงสุล", href: "/services/mfa-legalization" },
      { label: "Notary Public / ทนายผู้ทำคำรับรอง", href: "/notary" },
    ],
  },
  {
    slug: "legalization-th",
    titleTh: "แนะนำบริการรับรองเอกสาร สำหรับคนไทย",
    h1: "แนะนำบริการรับรองเอกสารสำหรับคนไทย 2026: กงสุล สถานทูต และทนายผู้ทำคำรับรอง",
    metaTitle: "แนะนำบริการรับรองเอกสาร คนไทย 2026 | กงสุล สถานทูต โนตารี",
    metaDesc:
      "แนวทางเลือกบริการรับรองเอกสารสำหรับคนไทย ทั้งนิติกรณ์กรมการกงสุล การรับรองสถานทูต และคำรับรองโดยทนายความ พร้อมลำดับขั้นที่ถูกต้อง ปรึกษาทีมงานได้",
    quickAnswer:
      "เอกสารไทยที่จะใช้ต่างประเทศต้องรับรองตามลำดับ คือทำคำแปลให้ถูกแบบ นำไปรับรองนิติกรณ์ที่กองสัญชาติและนิติกรณ์ กรมการกงสุล แล้วรับรองต่อที่สถานเอกอัครราชทูตของประเทศปลายทางเมื่อประเทศนั้นกำหนด ส่วนเอกสารที่ทำขึ้นเองเช่นหนังสือมอบอำนาจหรือหนังสือสาบานตน ต้องให้ทนายความผู้ทำคำรับรองลายมือชื่อและเอกสารรับรองก่อน",
    audience: "ไทย",
    intro: [
      "การรับรองเอกสารเป็นงานที่ลำดับขั้นสำคัญกว่าความเร็ว หากข้ามขั้นหรือสลับลำดับ เอกสารจะถูกปฏิเสธที่ปลายทางและต้องเริ่มใหม่ทั้งชุด",
      "หน้านี้จัดกลุ่มงานรับรองเอกสารตามชนิดเอกสารและปลายทางที่พบมากที่สุด พร้อมระบุหน่วยงานที่รับรองในแต่ละขั้น",
    ],
    serviceLinks: [
      { label: "รับรองนิติกรณ์กรมการกงสุล", href: "/services/mfa-legalization" },
      { label: "ทนายผู้ทำคำรับรองลายมือชื่อและเอกสาร", href: "/notary" },
      { label: "สถานทูตและสถานกงสุลในไทย", href: "/embassies" },
    ],
  },
  {
    slug: "legalization-foreign",
    titleTh: "แนะนำบริการรับรองเอกสาร สำหรับชาวต่างชาติ",
    h1: "แนะนำบริการรับรองเอกสารสำหรับชาวต่างชาติในประเทศไทย 2026",
    metaTitle: "แนะนำรับรองเอกสาร ชาวต่างชาติในไทย 2026 | Notary และกงสุล",
    metaDesc:
      "แนวทางเลือกบริการรับรองเอกสารสำหรับชาวต่างชาติในไทย ทั้งหนังสือสาบานตน หนังสือมอบอำนาจ รับรองพาสปอร์ต และเอกสารบริษัท ปรึกษาทีมงานได้",
    quickAnswer:
      "ชาวต่างชาติในไทยที่ต้องรับรองเอกสารมักใช้สองเส้นทาง เส้นทางแรกคือให้ทนายความผู้ทำคำรับรองลายมือชื่อและเอกสารซึ่งได้รับใบอนุญาตจากสภาทนายความรับรองลายมือชื่อและสำเนา เหมาะกับหนังสือสาบานตนและหนังสือมอบอำนาจ เส้นทางที่สองคือรับรองที่สถานเอกอัครราชทูตของประเทศตน แล้วนำไปรับรองต่อที่กรมการกงสุลเพื่อใช้ในไทย",
    audience: "ต่างชาติ",
    intro: [
      "ประเทศไทยไม่มีระบบ Notary Public แบบประเทศคอมมอนลอว์ แต่มีทนายความผู้ทำคำรับรองลายมือชื่อและเอกสารที่ได้รับใบอนุญาตจากสภาทนายความ ซึ่งทำหน้าที่เทียบเท่าในทางปฏิบัติและหน่วยงานต่างประเทศส่วนใหญ่ยอมรับ",
      "หน้านี้อธิบายว่าเอกสารแบบใดควรใช้ช่องทางใด และต้องรับรองซ้อนกี่ชั้นเพื่อให้ปลายทางรับ",
    ],
    serviceLinks: [
      { label: "Notarial Services Attorney", href: "/notary" },
      { label: "Apostille และนิติกรณ์กงสุล", href: "/services/hague-apostille-2026" },
      { label: "สถานทูตและสถานกงสุลในไทย", href: "/embassies" },
    ],
  },
  {
    slug: "visa-th",
    titleTh: "แนะนำบริการวีซ่า สำหรับคนไทยเดินทางต่างประเทศ",
    h1: "แนะนำบริการวีซ่าสำหรับคนไทย 2026: ท่องเที่ยว เรียนต่อ ทำงาน และติดตามครอบครัว",
    metaTitle: "แนะนำบริการวีซ่า คนไทย 2026 | ท่องเที่ยว เรียนต่อ ทำงาน",
    metaDesc:
      "แนวทางเลือกบริการยื่นวีซ่าสำหรับคนไทย ทั้งเชงเก้น อเมริกา อังกฤษ ออสเตรเลีย ญี่ปุ่น เกาหลี พร้อมเอกสารที่ต้องแปลและรับรอง ปรึกษาทีมงานได้",
    quickAnswer:
      "คนไทยที่ยื่นวีซ่าต่างประเทศควรเลือกผู้ให้บริการที่ทำงานเอกสารได้ครบวงจร คือแปลเอกสารให้ตรงแบบที่สถานทูตกำหนด รับรองนิติกรณ์เมื่อจำเป็น และจัดชุดหลักฐานการเงินกับหลักฐานความผูกพันกับประเทศไทยให้สอดคล้องกับเหตุผลการเดินทาง สิ่งที่ทำให้วีซ่าไม่ผ่านส่วนใหญ่ไม่ใช่แบบฟอร์ม แต่เป็นความไม่สอดคล้องของเอกสารประกอบ",
    audience: "ไทย",
    intro: [
      "การพิจารณาวีซ่าดูสองเรื่องเป็นหลัก คือวัตถุประสงค์การเดินทางที่ชัดเจนและความสอดคล้องของหลักฐานทั้งชุด บริการที่ช่วยได้จริงจึงไม่ใช่แค่กรอกแบบฟอร์ม แต่ต้องตรวจความสอดคล้องของเอกสารก่อนยื่น",
      "หน้านี้แยกกลุ่มบริการวีซ่าตามประเภทการเดินทางและกลุ่มประเทศปลายทาง พร้อมระบุเอกสารไทยที่ต้องแปลและรับรองในแต่ละกรณี",
    ],
    serviceLinks: [
      { label: "แปลเอกสารยื่นวีซ่า", href: "/translation" },
      { label: "ตรวจประวัติอาชญากรรมเพื่อยื่นวีซ่า", href: "/police-clearance" },
      { label: "รับรองนิติกรณ์กรมการกงสุล", href: "/services/mfa-legalization" },
    ],
  },
  {
    slug: "visa-foreign",
    titleTh: "แนะนำบริการวีซ่าไทย สำหรับชาวต่างชาติ",
    h1: "แนะนำบริการวีซ่าไทยสำหรับชาวต่างชาติ 2026: ทำงาน เกษียณ ครอบครัว และวีซ่าระยะยาว",
    metaTitle: "แนะนำบริการวีซ่าไทย ชาวต่างชาติ 2026 | DTV LTR Non-B เกษียณ",
    metaDesc:
      "แนวทางเลือกบริการวีซ่าไทยสำหรับชาวต่างชาติ ทั้ง DTV LTR Non-B วีซ่าเกษียณและวีซ่าครอบครัว พร้อมเอกสารที่ต้องแปลและรับรอง ปรึกษาทีมงานได้",
    quickAnswer:
      "ชาวต่างชาติที่ขอวีซ่าไทยควรเลือกประเภทวีซ่าตามกิจกรรมจริงที่จะทำในไทย ไม่ใช่ตามระยะเวลาที่อยากอยู่ เพราะเอกสารประกอบของแต่ละประเภทต่างกันมาก งานเอกสารที่ใช้เวลานานที่สุดมักเป็นเอกสารจากประเทศต้นทางที่ต้องรับรองและแปลเป็นภาษาไทย จึงควรเริ่มขั้นนี้ก่อนยื่นคำขออย่างน้อยหนึ่งเดือน",
    audience: "ต่างชาติ",
    intro: [
      "ประเภทวีซ่าไทยที่เลือกจะกำหนดทั้งเอกสารประกอบ การรายงานตัว และสิทธิในการทำงาน การเลือกผิดประเภทตั้งแต่ต้นทำให้ต้องออกนอกประเทศเพื่อเปลี่ยนประเภทในภายหลัง",
      "หน้านี้จัดกลุ่มบริการตามประเภทวีซ่าและสถานะของผู้ขอ พร้อมระบุเอกสารต่างประเทศที่ต้องรับรองและแปล",
    ],
    serviceLinks: [
      { label: "Long-term visas Thailand", href: "/en/services/long-term-visas" },
      { label: "Work permit และ Non-B", href: "/en/services/work-permit" },
      { label: "TM30 และรายงานตัว 90 วัน", href: "/en/services/tm30-90day" },
    ],
  },
];

export function getRecommendHub(slug: string): RecommendHub | undefined {
  return RECOMMEND_HUBS.find((h) => h.slug === slug);
}
